export enum LocationTypeCode {
  Client = 1,
  Region,
  District,
  Store
}
